import { Component, OnInit } from '@angular/core';
import { BasePage } from '../../base-page';
import { ApiService } from 'src/app/services/api.service';
import { BartenderItemModel } from 'src/app/models/bartenders/bartender-list-item.model';
import { BartenderUserVoteModel } from 'src/app/models/bartenders/bartender-user-vote.model';

@Component({
    selector: 'app-bartenders',
    templateUrl: './bartenders.component.html',
    styleUrls: ['./bartenders.component.scss'],
    standalone: false
})
export class BartendersComponent extends BasePage implements OnInit {

  private mCurrentBartender?: BartenderItemModel;

  private mItems: BartenderItemModel[] = [];

  public items: BartenderItemModel[] = [];

  public search: string = '';

  public isLoadVotes = false;
  public userVotes: BartenderUserVoteModel[] = [];


  constructor(private mApiService: ApiService) {
    super();
  }

  ngOnInit(): void {
    this.isBusy = true;
    this.mApiService.get<BartenderItemModel[]>('/api/admin/bartender/list').subscribe({
      next: r => {
        this.isBusy = false;
        this.mItems = this.items = r;

      },
      error: () => this.isBusy = false
    });
  }

  public showVotes(item: BartenderItemModel) {
    this.isLoadVotes = true;
    this.mApiService.get<BartenderUserVoteModel[]>(`/api/admin/bartender/${item.id}/votes`).subscribe({
      next: r => {
        this.isLoadVotes = false;
        this.userVotes = r;
      },
      error: () => this.isLoadVotes = false
    });
  }

  public searchItems() {
    const s = this.search.toLowerCase();
    this.items = this.mItems.filter(x => x.lastName!.toLowerCase().indexOf(s) > -1 || x.name!.toLowerCase().indexOf(s) > -1);
  }

  public deleteItem(item: BartenderItemModel) {
    if (!confirm('Удалить этого бармена?')) {
      return;
    }

    this.isBusy = true;
    this.mApiService.delete(`/api/admin/bartender/${item.id}`).subscribe({
      next: () => {
        this.isBusy = false;
        this.mItems.splice(this.mItems.indexOf(item), 1);
        this.searchItems();
      },
      error: () => this.isBusy = false
    });
  }
}
